import { ENVIRONMENTS, HOSTS_PER_ENV, getEnvironment } from './environment';

export const getSurveyExternalUrl = (uuid, surveysHost) => {
    if (surveysHost) {
        return `https://${surveysHost}/${uuid}`;
    }

    const environment = getEnvironment();
    const urlHost = HOSTS_PER_ENV[environment].SURVEYS;

    return `https://${urlHost}/${uuid}`;
};

export const isOffsiteSurvey = (url = document.location.href) => {
    const EXTERNAL_URLS = [
        HOSTS_PER_ENV[ENVIRONMENTS.LIVE].SURVEYS,
        HOSTS_PER_ENV[ENVIRONMENTS.REVIEW_WEBAPP].SURVEYS,
        HOSTS_PER_ENV[ENVIRONMENTS.REVIEW].SURVEYS,
        HOSTS_PER_ENV[ENVIRONMENTS.STAGING].SURVEYS,
        HOSTS_PER_ENV[ENVIRONMENTS.DEV].SURVEYS,
        HOSTS_PER_ENV[ENVIRONMENTS.DEV_OLD].SURVEYS
    ];

    // Some gymnastics because the URL constructor is not available on IE. Once
    // support for IE is dropped we can replace this by using the URL
    // constructor.
    const el = document.createElement('a');
    el.href = url;

    return EXTERNAL_URLS.indexOf(el.hostname) >= 0;
};
